import { ReactNode } from "react";

interface MobileContainerProps {
  children: ReactNode;
}

export const MobileContainer = ({ children }: MobileContainerProps) => {
  return (
    <div className="min-h-screen bg-muted flex items-center justify-center p-4">
      <div className="w-full max-w-[430px] min-h-[932px] bg-background rounded-[2.5rem] shadow-soft overflow-hidden relative border border-border/50">
        <div className="h-full overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};
